import Slider from 'react-slick';
import { useRef } from 'react';
// @mui
import {
  Dialog,
  DialogContent,
  Paper,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';
import { useTheme, styled } from '@mui/material/styles';
// hooks
import useResponsive from "../../../hooks/useResponsive";
// components
import DIOText from '../../../components/DIOText';
import Scrollbar from '../../../components/Scrollbar';
import { CarouselDots, CarouselArrows } from '../../../components/carousel';

const BlueText = styled('span')(({ theme }) => ({
  color: theme.palette.secondary.main,
}));

const CarouselTypo = styled(Typography)(({ theme }) => ({
  ...theme.typography.body2,
  [theme.breakpoints.up('sm')]: {
    ...theme.typography.body1,
  }
}));

const EXAMPLES = [
  {
    "id": 1,
    "name": "글로벌 1위 사진 생성AI 서비스 캐럿",
    "content": [
      <CarouselTypo key="1-1">
        캐럿은 치열한 생성 AI 프로필 시장에서 단 6명의 멤버로 200만 누적 가입, BEP 달성, 6개월 연속 MAU 성장한 팀입니다. 월 600만건의 사진 생성을 통해 최근 시리즈A 투자를 받았습니다. <br/>
        <br/>
        우리는 계속해서 불가능해보이는 일에 도전합니다.<br/>
        <br/>
        <b>카메라가 필요 없는 사진앱</b><br/>
        생성AI 기술을 통해 기존의 사진촬영 대비 100배 더 편리한 경험을 제공합니다. 촬영이 필요한 모든 순간 가장 먼저 찾는 제품으로 만듭니다.<br/>
        <br/>
        <b>강력한 유저 네트워크 기반의 콘텐츠 플랫폼</b><br/>
        AI콘텐츠로 캐럿만의 커뮤니티를 만듭니다. 크리에이터와 유저를 연결하여 유저들에게 가치를 제공하고, 이를 기반으로 강력한 해자를 구축합니다.<br/>
        <br/>
        <b>글로벌 1위 사진 생성AI서비스</b><br/>
        Lensa, Remini, Epik 등 미국에서도 다양한 AI사진 서비스들이 바이럴됐지만, 제품 성장을 유지하지 못했습니다. AI사진 서비스로서 유일하게 지속적인 제품성장을 만들어낸 캐럿팀의 경험과 역량을 바탕으로 글로벌 1위 서비스가 되는 것을 목표로 합니다.<br/>
        <br/>
        제품 페이지: https://carat.im/ <br/>
        채용 페이지: https://carat.career.greetinghr.com/ <br/>
        <br/>
        Flutter 기반의 앱을 서서히 React 로 바꿔나가고 있는 중이에요. 이 기술적인 도전을 리드해주실 분을 찾습니다.
      </CarouselTypo>
    ]
  },
  {
    "id": 2,
    "name": "오프라인 공간의 GA 서비스 메이아이",
    "content": [
      <CarouselTypo key="1-1">
        <b>메이아이는 오프라인 공간의 방문객 데이터 애널리틱스 툴 mAsh(매쉬)를 만드는 테크 스타트업입니다.</b><br/>
        <br/>
        온라인 매장들은 웹사이트에 방문한 고객들이 남긴 데이터를 분석하여 고객 경험을 개선하고 있습니다. 그렇다면 오프라인 매장은 어떨까요? 온라인 매장에서보다 훨씬 다양한 데이터들이 발생하고 있지만, 정량화된 데이터 분석은 거의 이루어지지 못하고 있습니다.<br/>
        <br/>
        메이아이는 공간에 설치되어 있는 CCTV의 영상을 활용하여, 영상 처리 인공지능으로 방문객들의 성별이나 연령대부터 동선, 체류 시간, 행동, 상품과의 인터랙션까지 모든 데이터를 분석합니다. 이를 바탕으로 오프라인 공간을 디지털화하고 분석 가능한 영역으로 만드는 일을 꿈꿉니다. <br/>
        <br/>
        현재 메이아이는 34명의 히치하이커와 함께 오프라인 공간의 미래를 만들어나가고 있습니다!<br/>
        <br/>
        제품 페이지: https://may-i.io/mash/ <br/>
        채용 페이지: https://recruit.may-i.io/
      </CarouselTypo>
    ],
  },
  {
    "id": 3,
    "name": "Global 태스크+일정 관리툴 오프라이트",
    "content": [
      <CarouselTypo key="1-1">
        오프라이트는 치열한 생산성 툴 시장에서 CBT 시작 7개월 만에 3.5만개의 태스크가 생성되었고, M+5 리텐션이 25% 가까이 나오는 제품을 만들어낸 팀입니다.<br/>
        <br/>
        제품과 뛰어난 팀에 대한 기대감을 기반으로 매쉬업, 베이스, 더벤처스 3곳에서 최근 시드 투자를 받았습니다.<br/>
        해외에서 통하는 생산선 툴을 만듭니다.<br/>
        <br/>
        <b>파편화된 SaaS의 경험을 유저를 중심으로 재구축합니다.</b><br/>
        Notion, Slack, Gmail 등 여러 서비스에 흩어져 있는 Task를 한곳으로 모아주어 SaaS에 흩뿌려진 알람을 찾으러 다니는 것이 아니라 유저에게 모아줍니다.<br/>
        <br/>
        <b>목표 중심 데일리 플래닝 </b><br/>
        목표를 생성 관리하고, 목표를 중심으로 태스크를 정리하여 정말 해야하는 오늘의 태스크를 선별하고, 캘린더와 함께 유기적으로 일정을 관리할 수 있도록 합니다.<br/>
        <br/>
        제품 페이지: https://www.offlight.work/
      </CarouselTypo>
    ],
  },
];


export default function FliersProfileExampleDialog({ isOpen, closeDialog }) {
  const smUp = useResponsive('up', 'sm');
  const theme = useTheme();
  const carouselRef = useRef(null);

  const settings = {
    dots: true,
    arrows: true,
    autoplay: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    rtl: Boolean(theme.direction === 'rtl'),
    ...CarouselDots({
      rounded: true,
      sx: { mt: 2 },
    }),
  };

  const handleNext = async () => {
    carouselRef.current?.slickNext();
  };

  const handlePrevious = async () => {
    carouselRef.current?.slickPrev();
  };

  return (
    <Dialog open={isOpen} onClose={closeDialog} fullWidth maxWidth="sm" fullScreen={!smUp}>
      <DialogContent sx={{ px: { xs: 3, sm: 4 }, pb: 0 }}>
        <Typography variant="h5" gutterBottom>
          🙋‍♀️ 다른 회사는 소개글을 이렇게 작성했어요.
        </Typography>
        <Typography variant="body1" sx={{ wordBreak: "keep-all" }}>
          실제 <DIOText />의 다른 기업 고객이 작성한 회사 소개글 예시입니다.
        </Typography>
        <Paper>
          <CarouselArrows
            onNext={handleNext}
            onPrevious={handlePrevious}
          >
            <Slider ref={carouselRef} {...settings}>
              {EXAMPLES.map((item) => (
                <CarouselItem key={item.id} item={item} />
              ))}
            </Slider>
          </CarouselArrows>
        </Paper>
      </DialogContent>
      <DialogActions sx={{ px: { xs: 3, sm: 4 }}}>
        <Button
          variant="contained"
          onClick={closeDialog}
          fullWidth={!smUp}
          size="large"
          sx={{ px: 5 }}
        >
          확인했어요
        </Button>
      </DialogActions>
    </Dialog>
  )
}

function CarouselItem({ item }) {
  return (
    <Paper
      sx={{
        p: 3,
        mt: 3,
        backgroundColor: "grey.200"
       }}>
      <Typography variant="subtitle1" gutterBottom>
        <BlueText>{item?.name}</BlueText>의 회사 소개 예시
      </Typography>
      <Paper
        sx={{ p: 3, my: 2 }}
      >
        <Scrollbar
          sx={{
            maxHeight: "320px",
            '& .simplebar-content': { height: 1, display: 'flex', flexDirection: 'column' },
          }}
        >
          {item.content?.map((t) => t)}
        </Scrollbar>
      </Paper>
    </Paper>
  )
}
